import { render, staticRenderFns } from "./ToothOldNumberMenu.vue?vue&type=template&id=60adb21c&scoped=true&"
import script from "./ToothOldNumberMenu.vue?vue&type=script&lang=js&"
export * from "./ToothOldNumberMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60adb21c",
  null
  
)

export default component.exports